module.exports = __webpack_public_path__ + "86a824f2a7cacee1bfe6baabde99c5c8.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/Instagram_20x20.svg
// module id = 155
// module chunks = 0